import { actionCreator } from 'utils';
import * as ResellerTypes from '../types/resellerTypes';

// L O A D   R E S E L L E R S
export function loadResellers() {
    return {
        type: ResellerTypes.LOAD_RESELLERS,
    };
}

export function loadResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_RESELLERS, 'res'),
        data,
    };
}

export function loadResellersErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_RESELLERS, 'err'),
    };
}
// L O A D   R E S E L L E R S

// S E T   R E S E L L E R S   F I L T E R
export function setResellersFilters(key, value) {
    return {
        type: ResellerTypes.SET_RESELLERS_FILTER,
        key,
        value,
    };
}

export function setResellersFiltersRes(data) {
    return {
        type: actionCreator(ResellerTypes.SET_RESELLERS_FILTER, 'res'),
        data,
    };
}

export function setResellerPagination(key, pagination) {
    return {
        type: ResellerTypes.SET_RESELLER_PAGINATION,
        key,
        pagination,
    };
}

export function setResellerSort(sort) {
    return {
        type: ResellerTypes.SET_RESELLER_SORT,
        sort,
    };
}
// S E T   R E S E L L E R S   F I L T E R

// A D D   N E W   R E S E L L E R S
export function addNewReseller(data) {
    return {
        type: ResellerTypes.ADD_NEW_RESELLER,
        data,
    };
}

export function addNewResellerRes(loading, success) {
    return {
        type: actionCreator(ResellerTypes.ADD_NEW_RESELLER, 'res'),
        loading,
        success,
    };
}

export function addNewResellerErr(error) {
    return {
        type: actionCreator(ResellerTypes.ADD_NEW_RESELLER, 'err'),
        error,
    };
}
// A D D   N E W   R E S E L L E R S

// E D I T   R E S E L L E R S
export function editReseller(data) {
    return {
        type: ResellerTypes.EDIT_RESELLER,
        data,
    };
}

export function editResellerRes(loading, success) {
    return {
        type: actionCreator(ResellerTypes.EDIT_RESELLER, 'res'),
        loading,
        success,
    };
}

export function editResellerErr() {
    return {
        type: actionCreator(ResellerTypes.EDIT_RESELLER, 'err'),
    };
}
// E D I T   R E S E L L E R S

// L O A D   E D I T A B L E   R E S E L L E R S
export function loadEditableReseller(id) {
    return {
        type: ResellerTypes.LOAD_EDITABLE_RESELLER,
        id,
    };
}

export function loadEditableResellerRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_RESELLER, 'res'),
        data,
    };
}

export function loadEditableResellerErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_RESELLER, 'err'),
    };
}

export function setEmptyEditableReseller() {
    return {
        type: ResellerTypes.SET_EMPTY_EDITABLE_RESELLER,
    };
}
// L O A D   E D I T A B L E   R E S E L L E R S

// R E S T   F I L T E R   R E S E L L E R S
export function resetFiltersResellers() {
    return {
        type: ResellerTypes.RESET_FILTER_RESELLERS,
    };
}

export function resetFiltersResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.RESET_FILTER_RESELLERS, 'res'),
        data,
    };
}
// R E S T   F I L T E R   R E S E L L E R S

// L O A D   R E S E L L E R   S E G M E N T S
export function loadResellerSegments(id) {
    return {
        type: ResellerTypes.LOAD_RESELLER_SEGMENTS,
        id,
    };
}

export function loadResellerSegmentsRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_RESELLER_SEGMENTS, 'res'),
        data,
    };
}

export function loadResellerSegmentsErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_RESELLER_SEGMENTS, 'err'),
    };
}
// L O A D   R E S E L L E R   S E G M E N T S

// L O A D   S E G M E N T S   F O R   R E S E L L E R S
export function loadSegmentsForResellers(value, parentId) {
    return {
        type: ResellerTypes.LOAD_SEGMENTS_FOR_RESELLERS,
        value,
        parentId,
    };
}

export function loadSegmentsForResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_SEGMENTS_FOR_RESELLERS, 'res'),
        data,
    };
}

export function loadSegmentsForResellersErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_SEGMENTS_FOR_RESELLERS, 'err'),
    };
}

export function setEmptySegmentsForResellers() {
    return {
        type: ResellerTypes.SET_EMPTY_SEGMENTS_FOR_RESELLERS,
    };
}
// L O A D   S E G M E N T S   F O R   R E S E L L E R S

// L O A D   P R O D U C T  G R O U P S   F O R   R E S E L L E R S
export function loadProductGroupsForResellers() {
    return {
        type: ResellerTypes.LOAD_PRODUCT_GROUPS_FOR_RESELLERS,
    };
}

export function loadProductGroupsForResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_PRODUCT_GROUPS_FOR_RESELLERS, 'res'),
        data,
    };
}

export function loadProductGroupsForResellersErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_PRODUCT_GROUPS_FOR_RESELLERS, 'err'),
    };
}

export function setProductGroupsPaginationForResellers(key, pagination) {
    return {
        type: ResellerTypes.SET_PRODUCT_GROUPS_PAGINATION_FOR_RESELLERS,
        key,
        pagination,
    };
}
// L O A D   P R O D U C T  G R O U P S   F O R   R E S E L L E R S

// S E T   P R O D U C T  G R O U P S   F I L T E R   F O R   R E S E L L E R S
export function setProductGroupsFiltersForResellers(key, value) {
    return {
        type: ResellerTypes.SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS,
        key,
        value,
    };
}

export function setProductGroupsFiltersForResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS, 'res'),
        data,
    };
}

export function resetProductGroupsFiltersForResellers() {
    return {
        type: ResellerTypes.RESET_PRODUCTS_GROUPS_FILTERS_FOR_RESELLERS,
    };
}
// S E T   P R O D U C T  G R O U P S   F I L T E R   F O R   R E S E L L E R S

// L O A D   S E G M E N T S   F O R   R E S E L L E R S
export function setActiveSegment(data) {
    return {
        type: ResellerTypes.SET_ACTIVE_SEGMENT,
        data,
    };
}

export function setEmptyActiveSegment() {
    return {
        type: ResellerTypes.SET_EMPTY_ACTIVE_SEGMENT,
    };
}
// L O A D   S E G M E N T S   F O R   R E S E L L E R S

// A D D   S E G M E N T   &   P R O D U C T   G R O U P
export function addSegmentProductGroup(id) {
    return {
        type: ResellerTypes.ADD_SEGMENT_PRODUCT_GROUP,
        id,
    };
}

export function addSegmentProductGroupRes(loading, success) {
    return {
        type: actionCreator(ResellerTypes.ADD_SEGMENT_PRODUCT_GROUP, 'res'),
        loading,
        success,
    };
}

export function addSegmentProductGroupErr(error) {
    return {
        type: actionCreator(ResellerTypes.ADD_SEGMENT_PRODUCT_GROUP, 'err'),
        error,
    };
}
// A D D   S E G M E N T   &   P R O D U C T   G R O U P

// D E L E T E   S E G M E N T   P R O D U C T   G R O U P
export function deleteSegmentProductGroup(resellerId, segmentId) {
    return {
        type: ResellerTypes.DELETE_SEGMENT_PRODUCT_GROUP,
        resellerId,
        segmentId,
    };
}

export function deleteSegmentProductGroupRes(loading, success) {
    return {
        type: actionCreator(ResellerTypes.DELETE_SEGMENT_PRODUCT_GROUP, 'res'),
        loading,
        success,
    };
}

export function deleteSegmentProductGroupErr(error) {
    return {
        type: actionCreator(ResellerTypes.DELETE_SEGMENT_PRODUCT_GROUP, 'err'),
        error,
    };
}
// D E L E T E   S E G M E N T   P R O D U C T   G R O U P

// L O A D   E D I T A B L E   S E G M E N T   F O R   R E S E L L E R S
export function loadEditableSegmentForResellers(id, parentId) {
    return {
        type: ResellerTypes.LOAD_EDITABLE_SEGMENT_FOR_RESELLERS,
        id,
        parentId,
    };
}

export function loadEditableSegmentForResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_SEGMENT_FOR_RESELLERS, 'res'),
        data,
    };
}

export function loadEditableSegmentForResellersErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_SEGMENT_FOR_RESELLERS, 'err'),
    };
}

export function setEmptyEditableSegmentForResellers() {
    return {
        type: ResellerTypes.SET_EMPTY_EDITABLE_SEGMENT_FOR_RESELLERS,
    };
}
// L O A D   E D I T A B L E   S E G M E N T   F O R   R E S E L L E R S

// L O A D   E D I T A B L E   S E G M E N T   P R O D U C T   G R O U P   F O R   R E S E L L E R S
export function loadSegmentProductGroupsForResellers(id, reseller) {
    return {
        type: ResellerTypes.LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS,
        id,
        reseller,
    };
}

export function loadSegmentProductGroupsForResellersRes(data) {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS, 'res'),
        data,
    };
}

export function loadSegmentProductGroupsForResellersErr() {
    return {
        type: actionCreator(ResellerTypes.LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS, 'err'),
    };
}
// L O A D   E D I T A B L E   S E G M E N T   P R O D U C T   G R O U P   F O R   R E S E L L E R S

// C H A N G E   R E S E L L E R   S E G M E N T   O R D E R
export function changeResellerSegmentOrder(resellerId) {
    return {
        type: ResellerTypes.CHANGE_RESELLER_SEGMENT_ORDER,
        resellerId,
    };
}

export function changeResellerSegmentOrderRes(loading, success) {
    return {
        type: actionCreator(ResellerTypes.CHANGE_RESELLER_SEGMENT_ORDER, 'res'),
        loading,
        success,
    };
}

export function changeResellerSegmentOrderErr(error) {
    return {
        type: actionCreator(ResellerTypes.CHANGE_RESELLER_SEGMENT_ORDER, 'err'),
        error,
    };
}
// C H A N G E   R E S E L L E R   S E G M E N T   O R D E R

// D E L E T E   I N V O I C E   T E M P L A T E
export function deleteInvoiceTemplate(data) {
    return {
        type: ResellerTypes.DELETE_INVOICE_TEMPLATE,
        data,
    };
}

export function deleteInvoiceTemplateRes(success) {
    return {
        type: actionCreator(ResellerTypes.DELETE_INVOICE_TEMPLATE, 'res'),
        success,
    };
}

export function deleteInvoiceTemplateErr(error) {
    return {
        type: actionCreator(ResellerTypes.DELETE_INVOICE_TEMPLATE, 'err'),
        error,
    };
}
// D E L E T E   I N V O I C E   T E M P L A T E
